/**
 * @fileoverview Agent definition for prose-continuer-guided.
 *
 * Guided continuation agent that advances a story within a defined chapter
 * structure (scenes, key events, storyline beats). The author has a plan and
 * wants to execute it incrementally.
 *
 * @category narrative.prose.drafting
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'prose-continuer-guided',
  kind: 'primitive',
  name: 'Continue (Guided)',
  description: 'Continues the story within the planned chapter structure, advancing through defined scenes and key events.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'narrative.prose.drafting',
    usedBy: [
      'use-content-creation-v2.ts',
      'use-ai-control-panel.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'prose-continuer-discovery',
      'chapter-drafter-v2',
      'draft-refiner-v2',
    ],
  },
};
